import { render, staticRenderFns } from "./fankui.vue?vue&type=template&id=0cd39d75&scoped=true"
import script from "./fankui.vue?vue&type=script&lang=js"
export * from "./fankui.vue?vue&type=script&lang=js"
import style0 from "./fankui.vue?vue&type=style&index=0&id=0cd39d75&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd39d75",
  null
  
)

export default component.exports